import { Editor } from '@tiptap/react';
import { Node as ProseMirrorNode } from '@tiptap/pm/model';

// -- moveBlock -----------------------------------------------------------------
// Moves the top-level block at `pos` one step up or down by swapping it with its
// sibling, as a single ProseMirror transaction. Used by the conversation
// message menu's Move up / Move down (in-editor drag is too fiddly to feel
// good). The transaction is naturally undoable and marks the editor dirty, so
// undo/redo and autosave need no special handling.
export function moveBlock(editor: Editor, pos: number, direction: 'up' | 'down'): void {
  const { state } = editor.view;
  const $pos = state.doc.resolve(pos);
  if ($pos.depth !== 0) {
    return;
  }
  const index = $pos.index(0);
  const node = state.doc.maybeChild(index);
  if (!node) {
    return;
  }

  const targetIndex = direction === 'up' ? index - 1 : index + 1;
  if (targetIndex < 0 || targetIndex >= state.doc.childCount) {
    return;
  }

  // Reorder the top-level blocks as a list, then replace the whole document
  // content with the new order in one transaction. Simpler and less error-prone
  // than offset arithmetic around the deletion, and still a single undoable
  // step that marks the editor dirty.
  const blocks: ProseMirrorNode[] = [];
  state.doc.forEach((child) => blocks.push(child));
  const moved = blocks[index];
  const neighbour = blocks[targetIndex];
  if (!moved || !neighbour) {
    return;
  }
  blocks[index] = neighbour;
  blocks[targetIndex] = moved;

  const tr = state.tr.replaceWith(0, state.doc.content.size, blocks);
  editor.view.dispatch(tr.scrollIntoView());
}
